import React from 'react';
import { motion } from 'framer-motion';
import BrandLogo from '../components/brand/BrandLogo';
import VisualPanel from '../components/common/VisualPanel';

const PlaceholderPage = ({ title }) => {
  return (
    <div className="h-full flex flex-col items-center justify-center text-center p-8">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4 }}
        className="max-w-md"
      >
        <VisualPanel type="empty" className="mb-8 h-40 w-full" />
        <div className="flex items-center justify-center gap-3 mb-4">
          <BrandLogo size="md" />
          <h1 className="text-2xl font-bold text-white">{title} Protocol</h1>
        </div>
        <p className="text-slate-400 leading-relaxed font-medium">
          The <span className="text-violet-400">{title}</span> module is currently calibrating. Live telemetry routing will commence in the next patch sequence.
        </p>
        <div className="mt-8 flex justify-center gap-2">
          <div className="w-1.5 h-1.5 rounded-full bg-slate-700"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-slate-700"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-slate-700"></div>
        </div>
      </motion.div>
    </div>
  );
};

export default PlaceholderPage;